import React from 'react';

import { link } from '../../helpers/link';
import './DiscountProgramOverview.scss';
import images from '../../shared/assets/images';

const {
  infographics1,
  infographics2,
  infographics3,
  infographics4,
  infographics5,
  infographics6,
  infographics7,
  infographics8
} = images;

export default function DiscountProgramOverview(props) {
  const { section } = props;

  return (
    <section className="discountProgramOverview">
      {section === 'intro' && (
        <div className="discountProgramOverview_intro">
          <div className="discountProgramOverview_header">
            <p className="discountProgramOverview_title">
              Wat is het familie voordeelprogramma?
            </p>
          </div>

          <p>
            Wie wilt nu niet honderden euro’s in één klap besparen op alle
            zwangerschapsspullen, babyspullen en leuke gezinsuitjes? Dit kan nu
            met het Familie Voordeel Programma!
          </p>

          <p>
            Het Familie Voordeel Programma is speciaal ontworpen voor gezinnen
            of koppels die in verwachting zijn of net een gezinsuitbreiding
            hebben mogen ontvangen. Met dit voordeelprogramma kun je namelijk
            hoge kortingen pakken op de gehele babyuitzet, zwangerschapskleding,
            babykleding, zwangerschapscursussen en leuke familie uitjes. Alle
            producten zijn van de beste merken, omdat jouw gezin natuurlijk
            alleen het beste verdient. Zie jij het dus wel zitten om baby- en
            kinderkleding te scoren mét korting van merken als Koeka, Difrax,
            ByKay, Hema, Joolz, Snoozebaby, Cottonbaby en Jollein? Dan word jij
            héél erg blij van het Familie Voordeel Programma!
          </p>

          <Button />
        </div>
      )}

      {section === 'top' && (
        <div className="discountProgramOverview_infographics">
          <Title />

          <ul>
            <li>
              <img src={infographics1} alt="infographics" />

              <p>Het grootste aanbod</p>

              <p>
                Met meer dan 125 aangesloten partijen is er voor ieder wat wils!
                Merken als Koeka, Difrax, ByKay, Hema, Joolz, Snoozebaby,
                Cottonbaby en Jollein vind je hier allemaal met korting.
              </p>
            </li>

            <li>
              <img src={infographics2} alt="infographics" />

              <p>Landelijk én lokaal</p>

              <p>
                Een babywinkel dichtbij huis, tot een gezinsuitstapje aan de
                andere kant van het land!
              </p>
            </li>

            <li>
              <img src={infographics3} alt="infographics" />

              <p>Voordeel op alles voor de zwangershap en daarna</p>

              <p>
                je kunt ook na je zwangerschap blijven besparen op uitjes,
                kleding, diensten en kado’s.
              </p>
            </li>

            <li>
              <img src={infographics4} alt="infographics" />

              <p>Voor slechts 14,95 per jaar</p>

              <p>
                Voor dit kleine bedrag krijg jij toegang tot het hele Familie
                Voordeel Programma. Je verdient het haast gelijk weer terug!
              </p>
            </li>
          </ul>

          <Button />
        </div>
      )}

      {section === 'bottom' && (
        <div
          id="discountProgramOverview_bottom_section"
          className="discountProgramOverview_infographics"
        >
          <Title />

          <ul>
            <li>
              <img src={infographics5} alt="infographics" />

              <p>Meld je aan</p>

              <p>
                Meld je aan voor het Familie Voordeelprogramma! Waar wacht je
                nog op?
              </p>
            </li>

            <li>
              <img src={infographics6} alt="infographics" />

              <p>Betaal je lidmaatschap</p>

              <p>
                Door maar 14,95 per jaar te betalen, krijg je toegang tot alle
                kortingen en aanbiedingen van het Familie Voordeel Programma!
              </p>
            </li>

            <li>
              <img src={infographics7} alt="infographics" />

              <p>Begin met het online shoppen met korting</p>

              <p>
                Blader door al onze aanbiedingen en kies wat jij graag wilt
                hebben.
              </p>
            </li>

            <li>
              <img src={infographics8} alt="infographics" />

              <p>Ontvang de kortingscode en betaal bij de aanbieder</p>

              <p>
                Met de kortingscode van het Familie Voordeel Programma kun je
                met korting het product, dienst of activiteit kopen bij de
                aanbieder.
              </p>
            </li>
          </ul>

          <Button />
        </div>
      )}
    </section>
  );
}

function Button() {
  return link(
    <button className="discountProgramOverview_button">Aanmelden</button>,
    '/discount-program-register'
  );
}

function Title() {
  return (
    <p className="discountProgramOverview_title">
      Wat zijn de voordelen van het familie voordeelprogramma?
    </p>
  );
}
